module.exports = __webpack_public_path__ + "media/assets/images/blog/laptop_doc-small-9cbd6d573215a5dc548d67cf0ee3afc6.png";